// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vd__2MOeN","button":"vd__-G0RO","tooltipText":"vd__1UwGh"};